import { apiSlice } from "app/api/apiSlice"

export const costRefundApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['CostRefund', 'MyCostRefund'],
    endpoints: builder => ({

        getCostRefundDetail: builder.query({
            query: (guid) => {
                return {
                    url: 'hr/costRefund/detail',
                    params: {
                        costRefundGUID: guid
                    }
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['CostRefund']
        }),
        getCostRefunds: builder.query({
            query: (pageNumber) => {
                return {
                    url: 'hr/costRefund',
                    params: {
                        page: pageNumber
                    }
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['CostRefund']
        }),
        getMyCostRefunds: builder.query({
            query: (pageNumber) => {
                return {
                    url: 'hr/costRefund/me',
                    params: {
                        page: pageNumber
                    }
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['MyCostRefund']
        }),
        createCostRefund: builder.mutation({
            query: (
                request
            ) => ({
                url: 'hr/costRefund',
                method: 'POST',
                body: request
            }),
            invalidatesTags: ['MyCostRefund']
        }),
        // UPDATE CostRefund
        updateMyCostRefund: builder.mutation({
            query: costRefundUpdate => ({
                url: 'hr/costRefund',
                method: 'PUT',
                body: costRefundUpdate
            }),
            invalidatesTags: ['MyCostRefund']
        }),
        // UPDATE CostRefund STATUS
        updateCostRefundStatus: builder.mutation({
            query: costRefundStatusUpdate => ({
                url: 'hr/costRefund/status',
                method: 'PUT',
                body: costRefundStatusUpdate
            }),
            invalidatesTags: ['CostRefund', 'MyCostRefund']
        }),
        getCostRefundReport: builder.query({
            query: interval => {

                const { start, end } = interval;
                return {
                    url: 'hr/costRefund/report',
                    keepUnusedDataFor: 5,
                    params: { start: start, end: end }
                }
            }
        }),
    })
})

export const {
    useGetCostRefundDetailQuery,
    useGetCostRefundsQuery,
    useGetMyCostRefundsQuery,
    useCreateCostRefundMutation,
    useUpdateMyCostRefundMutation,
    useUpdateCostRefundStatusMutation,
    useLazyGetCostRefundReportQuery

} = costRefundApiSlice
